import React, { useRef } from "react";

export default function VideoPlayer({ url, poster, description, onClick }) {
    const videoRef = useRef(null);

    const handlePlay = () => {
        document.querySelectorAll("video").forEach(v => {
            if (v !== videoRef.current) v.pause();
        });
    };

    return (
        <div className="pdf-box position-relative" onClick={onClick}>
            <h3 title={description}>{description}</h3>
            <video ref={videoRef} poster={poster} controls disablePictureInPicture style={{ width: "100%" }} preload="metadata" onPlay={handlePlay}>
                <source src={url} type="video/mp4" />
                Your browser doesn’t support HTML5 video.
            </video>
        </div>
    );
}
